<template>
  <div style="margin-bottom: 10%" class="mobile-order-container">
    <mbHeader :title="$t('orderDetail')" :left="true" :lang="true"></mbHeader>
    <div class="category-buttons-order">
      <ul class="order-cats">
        <li class="order-cat" v-for="(item, index) in allGroups">
          <div class="group-button-container">
            <div class="image-placeholder" @click="navGo(item.ProductGroup_id)">
              <img class="button-image" :src="item.Image" alt="">
            </div>
            <p v-if="$i18n.locale == 'en'" class="group-button-name">{{ item.Name }}</p>
            <p v-if="$i18n.locale == 'ch'" class="group-button-name">{{ item.Description }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="account" v-if="!isMobile">
      <div class="breadcrumb-container">
        <img class="bread-img" :style="{cursor: 'pointer'}" src="../assets/img/breadcrumb-home.png"
             @click="$router.push('/home')">
        <el-breadcrumb class="breadcrumb-products" separator="/">
          <el-breadcrumb-item><a class="bread-text no-pointer">{{ $t('myAccount') }}</a></el-breadcrumb-item>
          <el-breadcrumb-item><a class="bread-text">{{ $t('myOrders') }}</a></el-breadcrumb-item>
          <el-breadcrumb-item><a class="bread-text">Order # {{ orderDetail.SONum }}</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="main-content">
        <!-- login  -->
        <div v-show="loggedIn===true" class="page-width">
          <h3>{{$t('delivered')}}</h3>
          <div class="order-info">
            <div class="orderDetails">
              <p class="order-title">{{ $t('delivery_for') }}</p>
              <p class="order-txt">{{ userDetails.FirstName }} {{ userDetails.LastName }}</p>
              <p v-if="userDetails && userDetails.phone" class="order-txt">{{$t('phone_no')}}: {{ userDetails.phone }}</p>
            </div>
            <div class="orderDetails">
              <p class="order-title">{{ $t('delivery_method') }}</p>
              <p class="order-txt">{{ orderDetail.ShippingMethod }}</p>
              <p v-if="orderDetail && orderDetail.ShippingMethod === 'Delivery'" class="order-txt">{{ $t('delivery_date') }}:
                {{ orderDetail.TimeSlot }}</p>
            </div>
            <div class="orderDetails" v-if="orderDetail.ShippingMethod === 'Delivery'">
              <p class="order-title">{{ $t('shipping_address') }}</p>
              <p class="order-txt">{{ orderDetail.Shipping_Address.Street }}, {{ orderDetail.Shipping_Address.City }}
                WA, {{ orderDetail.Shipping_Address.Zip }}</p>
              <p class="order-txt" v-if="orderDetails && orderDetails.Shipping_Address && orderDetails.Shipping_Address.Cellphone">
                {{ orderDetails.Shipping_Address.Cellphone }}</p>
            </div>
            <div class="orderDetails">
              <p class="order-title">{{ $t('billing_address') }}</p>
              <p class="order-txt">{{ billingAddress.AddressName }}, {{ billingAddress.City }} {{ billingAddress.State }},
                {{ billingAddress.Zip }}</p>
            </div>
            <!-- <div class="orderDetails">
              <p class="order-title">Payment Information</p>
            </div> -->
          </div>
          <div class="order-summary">
            <div class="order-head">
              <h3>{{ $t('orderSummary') }}</h3>
              <p @click="goToReview">{{$t('rate_experience')}}</p>
            </div>
            <ul>
              <li class="order-card" v-for="(item, index) in orderDetail.Sales_Order_Line" data-index="index"
                  :key="index">
                <img class="prod-img" :src="item.Thumbnail"/>
                <div class="prod-desc">
                  <p class="prod-brand">{{ curIsEnglish ? item.English_Details_Brand : item.Chinese_Details_Brand }}</p>
                  <p class="prod-name">{{ curIsEnglish ? item.ProductName : item.ProductDescription }}</p>
                  <p></p>
                </div>
                <p class="prod-price">${{ item.TotalPrice }}</p>
                <p class="prod-quant">x{{ item.Quantity }}</p>
                <button class="prod-add" @click="throttleAddToCart(item, $event)">{{ $t('addToCart') }}</button>
              </li>
            </ul>
            <div class="order-cost">
              <div class="cost-row">
                <p class="cost-txt">{{ $t('subtotal_afm') }}</p>
                <p class="cost-txt">${{ orderDetail.TotalPrice }}</p>
              </div>
              <div class="cost-row">
                <p class="cost-txt">{{ $t('discount') }}</p>
                <p class="cost-txt">-${{ orderDetail.Savings }}</p>
              </div>
              <div class="cost-row">
                <p class="cost-txt">{{$t('shipping_fee')}}</p>
                <p class="cost-txt">${{ orderDetail.Delivery }}</p>
              </div>
              <div class="cost-row">
                <p class="cost-txt">{{$t('tax_afm')}}</p>
                <p class="cost-txt">${{ orderDetail.TaxAmount }}</p>
              </div>
              <div class="cost-row">
                <p class="cost-total">{{ $t('total_afm') }}</p>
                <p class="cost-total">${{ orderDetail.GrandTotal }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-account" v-else>
      <mobileAccount
        @goToReview="goToReview"
        :orderDetail="orderDetail"
        :orderDetails="orderDetails"
        :userDetails="userDetails"
        :curIsEnglish="curIsEnglish"
        :billingAddress="billingAddress">
      </mobileAccount>
    </div>
    <div class="page-width" v-if="!isMobile">
      <pcRecommended class="pc-recommended-container"></pcRecommended>
      <recommended class="mobile-recommended-container"></recommended>
      <div class="recommended-more-container">
        <button class="recommended-more-button" @click="clickShowMoreRecommended()">{{ $t('showMore') }}</button>
      </div>
<!--      <div class="bottom-temp">-->
<!--        <img src="../assets/img/bottomtemp.png" alt="">-->
<!--      </div>-->
      <div class="home-footer">
        <div class="icon-col" style="borderRight: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../assets/img/headset.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{$t('customer_service')}}</h2>
            <p>{{ $t('call_chat_visit') }}</p>
          </div>
        </div>
        <div class="icon-col">
          <div class="homeFooter-img">
            <img src="../assets/img/truckHome.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('free_shipping') }}</h2>
            <p>{{ $t('get_shopafm_free') }}</p>
          </div>
        </div>
        <div class="icon-col" style="borderLeft: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../assets/img/onlinePayment.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{$t('online_payment')}}</h2>
            <p>{{ $t('we_accept_all') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapActions, mapState, mapMutations} from 'vuex';

import breadcrumb from '../components/breadcrumb';
import Router from '../router';
import productCard from "./productCard";
import pcRecommended from "../components/pc-recommended/pc-recommended";
import recommended from "./recommended";
import mbHeader from "../components/mobile/mbHeader";
import mobileAccount from "../components/mobile/mobile-account";
import {
  isUserAuthenticated,
} from "../store/modules/cart";
import {locales} from "../mixin";
import busUtil from "../assets/js/util";

export default {
  name: "order",
  loaded: false,
  mixins: [locales],
  components: {
    breadcrumb,
    productCard,
    pcRecommended,
    mbHeader,
    recommended,
    mobileAccount
  },
  data() {
    return {
      path2: '',
      billingAddress: {},
      orderDetail: {
        Sales_Order_Line: [],
        Shipping_Address: {},
        FinalPrice: '',
        GrandTotal: '',
        Delivery: '',
        SONum: '',
        OrderDate: '',
        DispatchDate: '',
        PaymentStatus: '',
        SaleStatus: '',
        TaxAmount: '',
        TotalPrice: '',
        TimeRange: '',
        Savings: '',
      },
      hasInvoice: false,
      invoiceDetail: {
        Sales_Order_Line: [],
        Shipping_Address: {},
        FinalPrice: '',
        GrandTotal: '',
        Delivery: '',
        SONum: '',
        OrderDate: '',
        DispatchDate: '',
        PaymentStatus: '',
        SaleStatus: '',
        TaxAmount: '',
        TotalPrice: '',
        TimeRange: '',
        Savings: '',
      }
    }
  },
  methods: {
    ...mapActions('orders', ['fetchOrderByTimeFrame', 'fetchSODetails', 'fetchSIDetails', 'fetchOrderDetails']),
    ...mapActions('addresses', ['fetchAddresses']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    goToReview() {
      this.$router.push({name: 'account', params: {component: 'Review'}});
    },
    fetchOrderDetail(orderId) {
      this.fetchSODetails(orderId)
        .then(res => {
          this.orderDetail = res.data;
          this.billingAddress = res.data.Billing_Address;
          // this.fetchBillingAddress(res.data.Billing_CustomerDetail_id)
        })
        .catch(err => {
          console.log('fetchOrderDetail error: ', err);
        })
    },
    fetchInvoiceDetail(orderId) {
      this.fetchSIDetails(orderId)
        .then(res => {
          this.invoiceDetail = res.data;
          this.hasInvoice = true;
        })
        .catch(err => {
          this.hasInvoice = false;
          console.log('fetchInvoiceDetail error: ', err);
        })
    },
    navGo(id) {
      const group = this.allGroups.filter(group => group.ProductGroup_id === id)[0];
      if (this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if (this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        } else {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        }
      } else {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewGroup(group);
        }, 600);
      }
    },
    isOutOfStock(item) {
      if (item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    throttleAddToCart: _.debounce(function (item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function (item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/getCart');
          }
        });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
      }
    },
    clickShowMoreRecommended() {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.showMoreRecommend();
      }, 600);
    },
    // old fetch billing func
    // fetchBillingAddress(billingId) {
    //   console.log("deets:", this.customerDetails)
    //   this.customerDetails && this.customerDetails.map(address => {
    //     if (address.CustomerDetail_id === billingId) {
    //       this.billingAddress = address;
    //       return;
    //     }
    //   });
    // },
    getOrderTime(OrderDate) {
      return moment(OrderDate).format('MMMM Do YYYY, h:mm:ss a');
    },
    getEstTime(DispatchDate) {
      return moment(DispatchDate).format('MMMM Do YYYY');
    },
    getAmount(price) {
      return parseFloat(price).toFixed(2);
    },
    initPage() {
      this.$store.dispatch('products/fetchCustomCategories');
      this.fetchAddresses();
      this.orderId = this.$route.params.order_id;
      this.fetchOrderDetail(this.orderId);
      this.fetchInvoiceDetail(this.orderId);
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    orderTimeFrame: state => state.order.orderTimeFrame,
    userDetails: state => state.auth.userDetails,
    customerDetails: state => state.addresses.customerDetails,
    addToCartLoading: state => state.cart.addToCartLoading,
    allGroups: state => state.navbar.allGroups,
    orderDetails: state => state.orders.orderDetails,
    windowWidth: state => state.navbar.windowWidth,
    isMobile() {
      return this.windowWidth < 800;
    },
  }),
  watch: {
    $route() {
      // this.$router.go(this.$route);
    }
  },
  mounted() {
    // this.initPage()
    this.$nextTick(() => {
      if (this.afm_activated) {// 已经执行过activated钩子
        return
      }
      this.initPage()
    })
  },
  activated() {
    this.afm_activated = true
    this.initPage()
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/order.less";
</style>



// WEBPACK FOOTER //
// src/view/order.vue